/* You Fly LA page kit (r8) — assets/yh-pages.js
   Loaded with defer after assets/yh-home.js on page templates whose suffix starts with "yh-" (layout/theme.liquid).
   One init per component (sections/yh-p-*.liquid carry data-yhp="<name>"); each runs inside try/catch, so one failing
   never stops the rest, and each section gets .is-ready when done. Markup is complete server-side (crawlable, readable
   without JavaScript); this script only adds behaviour. Theme editor: sections re-initialise on shopify:section:load.
   Global: window.YHP only. Nothing here calls preventDefault / stopPropagation on booking links (/products/…,
   /pages/book-a-consultation, #discovery), #enroll / /#enroll / [data-enroll] / [data-pick], [data-yfla-contact],
   /pages/contact or tel: links — assets/yfla-book.js and the pop-ups keep handling those. */
(function () {
'use strict';
if (window.YHP) return;

const $ = (s, r) => (r || document).querySelector(s);
const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
const MQ = { phone: matchMedia('(max-width: 700px)'), desk: matchMedia('(min-width: 1100px)'), reduce: matchMedia('(prefers-reduced-motion: reduce)') };
const IC = { close: 'M6 6l12 12M18 6L6 18', chevL: 'M15 6l-6 6 6 6', chevR: 'M9 6l6 6-6 6' };
const icon = (d, size) => `<svg class="yh-ic" width="${size}" height="${size}" viewBox="0 0 24 24" aria-hidden="true"><path d="${d}"/></svg>`;
const warn = (tag, e) => { if (window.console) console.warn('yh-pages', tag, e); };

/* horizontal swipe on touch / pen / mouse drag (same thresholds as the homepage) */
function onSwipe(el, cb) {
  let x0 = null, y0 = 0, t0 = 0;
  el.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse' && e.button !== 0) return; x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); });
  el.addEventListener('pointerup', (e) => {
    if (x0 === null) return;
    const dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2 && Date.now() - t0 < 800) { el.dataset.swiped = '1'; cb(dx < 0 ? 1 : -1); setTimeout(() => { delete el.dataset.swiped; }, 50); }
  });
  el.addEventListener('pointercancel', () => { x0 = null; });
}
/* Horizon scrolls .page-wrapper (not the window) at >= 990px; html[scroll-lock] is its own lock for both */
function lockScroll(on) {
  const h = document.documentElement;
  h.style.overflow = on ? 'hidden' : '';
  if (on) h.setAttribute('scroll-lock', ''); else h.removeAttribute('scroll-lock');
}

/* =====================================================================
   OPEN NOW — hours in Los Angeles time (Find Us, CTA band)
   ===================================================================== */
function laHour() {
  try {
    const p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    const g = (t) => +((p.find((x) => x.type === t) || {}).value || 0);
    return (g('hour') % 24) + g('minute') / 60;
  } catch (e) { return null; }
}
const hourLabel = (h) => { h = ((h % 24) + 24) % 24; return (h % 12 || 12) + (h >= 12 ? ' PM' : ' AM'); };
function openNow(root) {
  const open = +(root.dataset.open || 9), close = +(root.dataset.close || 21);
  const badges = $$('[data-open-badge]', root);
  if (!badges.length) return;
  function tick() {
    const t = laHour();
    if (t === null) return;
    const on = t >= open && t < close;
    badges.forEach((b) => {
      b.classList.add('is-live');
      b.classList.toggle('is-closed', !on);
      b.textContent = on ? 'Open Now · Until ' + hourLabel(close) : 'Closed Now · Opens ' + hourLabel(open) + (t >= close ? ' Tomorrow' : '');
    });
  }
  tick();
  setInterval(tick, 60000);
}

/* =====================================================================
   FULL-SCREEN VIEWER — the homepage viewer (assets/yh-home.js), fed with URLs instead of media-map keys.
   Same classes (styled by yh-home.css), own ids so it can live next to the homepage one.
   ===================================================================== */
const Viewer = (function () {
  let dlg = null, img, cap, fig, list = [], i = 0, onChange = null, opener = null;
  function build() {
    const wrap = document.createElement('div');
    wrap.className = 'yh yhp-vwrap';
    wrap.innerHTML = `<dialog class="yh-viewer" id="yhp-viewer" aria-label="Photo Viewer"><div class="yh-viewer__top"><p class="yh-viewer__cap" id="yhp-v-cap" aria-live="polite"></p><button type="button" class="yh-ib yh-ib--dark" aria-label="Close" id="yhp-v-close">${icon(IC.close, 20)}</button></div>`
      + `<figure class="yh-viewer__fig" id="yhp-v-fig"><img id="yhp-v-img" alt="" draggable="false" sizes="100vw"></figure>`
      + `<button type="button" class="yh-ib yh-ib--dark yh-viewer__prev" aria-label="Previous Photo" id="yhp-v-prev">${icon(IC.chevL, 20)}</button><button type="button" class="yh-ib yh-ib--dark yh-viewer__next" aria-label="Next Photo" id="yhp-v-next">${icon(IC.chevR, 20)}</button></dialog>`;
    document.body.appendChild(wrap);
    dlg = $('#yhp-viewer', wrap); img = $('#yhp-v-img', wrap); cap = $('#yhp-v-cap', wrap); fig = $('#yhp-v-fig', wrap);
    dlg.addEventListener('close', onClose);
    $('#yhp-v-close', wrap).addEventListener('click', close);
    $('#yhp-v-prev', wrap).addEventListener('click', () => go(-1));
    $('#yhp-v-next', wrap).addEventListener('click', () => go(1));
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'Escape' && typeof dlg.showModal !== 'function') close();
    });
    dlg.addEventListener('click', (e) => { if ((e.target === dlg || e.target === fig) && !fig.dataset.swiped) close(); });
    onSwipe(fig, go);
  }
  function show() {
    const g = list[i];
    if (g.srcset) img.setAttribute('srcset', g.srcset); else img.removeAttribute('srcset');
    img.setAttribute('src', g.src);
    img.alt = g.alt || '';
    cap.textContent = (g.cap || 'You Fly LA · Van Nuys Airport') + ' · ' + (i + 1) + ' / ' + list.length;
    const multi = list.length > 1;
    $('#yhp-v-prev').hidden = !multi; $('#yhp-v-next').hidden = !multi;
    if (onChange) onChange(i);
  }
  function go(d) { if (list.length < 2) return; i = (i + d + list.length) % list.length; show(); }
  function open(l, k, cb) {
    if (!dlg) build();
    list = l; i = k || 0; onChange = cb || null; opener = document.activeElement;
    show();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    lockScroll(true);
    $('#yhp-v-close').focus();
  }
  function close() { if (!dlg) return; if (typeof dlg.close === 'function') dlg.close(); else { dlg.removeAttribute('open'); onClose(); } }
  function onClose() { lockScroll(false); if (opener && opener.focus) opener.focus({ preventScroll: true }); }
  return { open: open, close: close, isOpen: () => !!(dlg && dlg.open) };
})();

/* =====================================================================
   HERO — the optional video is paused and hidden under reduced motion (the photo shows)
   ===================================================================== */
function initHero(root) {
  const v = $('.yhp-hero__vid', root);
  if (!v) return;
  const apply = () => {
    if (MQ.reduce.matches) { v.pause(); v.hidden = true; }
    else { v.hidden = false; const p = v.play && v.play(); if (p && p.catch) p.catch(() => {}); }
  };
  apply();
  if (MQ.reduce.addEventListener) MQ.reduce.addEventListener('change', apply);
}

/* =====================================================================
   FACTS — pressing a tile shows its detail line
   ===================================================================== */
function initFacts(root) {
  const btns = $$('button.yhp-stat', root), ds = $$('.yhp-facts__d', root);
  if (!btns.length) return;
  const set = (i) => {
    btns.forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.i === i)));
    ds.forEach((d) => d.classList.toggle('is-on', +d.dataset.i === i));
  };
  btns.forEach((b) => b.addEventListener('click', () => set(+b.dataset.i)));
  set(+btns[0].dataset.i);
}

/* =====================================================================
   NEAR ME — picker (typed / datalist / pins), straight-line miles, directions, list sort
   Same formula as sections/yh-p-nearme.liquid: miles = 69.093 * sqrt(dlat^2 + (0.827 * dlng)^2)
   ===================================================================== */
function initNearMe(root) {
  const K = 0.827, MPD = 69.093;
  const lat0 = +root.dataset.lat, lng0 = +root.dataset.lng, ppm = +root.dataset.ppm || 20;
  const dest = root.dataset.dest || '', sfx = root.dataset.sfx || '', place = root.dataset.place || 'Van Nuys Airport';
  const list = $('.yhp-near__list', root), res = $('.yhp-near__res', root), input = $('.yhp-near__in', root), go = $('.yhp-near__go', root);
  const line = $('.yhp-near__line', root), pins = $$('.yhp-pin[data-i]', root);
  const items = $$('.yhp-near__li', root).map((li) => {
    const a = { li: li, i: +li.dataset.i, name: li.dataset.name || '', lat: +li.dataset.lat, lng: +li.dataset.lng, url: li.dataset.url || '', note: li.dataset.note || '', label: li.dataset.label || li.dataset.name || '' };
    const dx = (a.lng - lng0) * K * MPD, dy = (a.lat - lat0) * MPD;
    a.mi = Math.sqrt(dx * dx + dy * dy); a.x = 500 + dx * ppm; a.y = 350 - dy * ppm;
    a.pin = pins.find((p) => +p.dataset.i === a.i) || null;
    return a;
  });
  if (!items.length || !res) return;
  const f = (k) => $(`[data-f="${k}"]`, res);
  const dirURL = (origin) => 'https://www.google.com/maps/dir/?api=1&origin=' + encodeURIComponent(origin) + '&destination=' + dest;
  function miles(mi) {
    if (mi < 1) return { n: '<1', unit: 'Mile', lbl: 'Less Than A Mile From ' + place };
    const r = Math.round(mi);
    return { n: String(r), unit: r === 1 ? 'Mile' : 'Miles', lbl: 'About ' + r + ' ' + (r === 1 ? 'Mile' : 'Miles') + ' From ' + place };
  }
  function select(a) {
    const t = miles(a.mi);
    res.classList.remove('is-free');
    $('.yhp-near__big', res).hidden = false;
    f('name').textContent = a.name; f('n').textContent = t.n; f('unit').textContent = t.unit; f('lbl').textContent = t.lbl;
    f('note').textContent = a.note; f('note').hidden = !a.note;
    f('dir').setAttribute('href', dirURL(a.name + sfx));
    const pg = f('page');
    if (a.url) { pg.setAttribute('href', a.url); pg.hidden = false; f('plabel').textContent = a.label || a.name; } else pg.hidden = true;
    pins.forEach((p) => p.classList.toggle('is-on', +p.dataset.i === a.i));
    items.forEach((b) => b.li.classList.toggle('is-on', b === a));
    if (line) {
      if (a.pin) { line.setAttribute('x1', a.x.toFixed(1)); line.setAttribute('y1', a.y.toFixed(1)); line.style.display = ''; }
      else line.style.display = 'none';
    }
  }
  function free(q) {
    res.classList.add('is-free');
    f('name').textContent = q;
    $('.yhp-near__big', res).hidden = true;
    f('lbl').textContent = 'Not On Our List Yet — Here Are Directions From There';
    f('note').hidden = true;
    f('dir').setAttribute('href', dirURL(q));
    f('page').hidden = true;
    pins.forEach((p) => p.classList.remove('is-on'));
    items.forEach((b) => b.li.classList.remove('is-on'));
    if (line) line.style.display = 'none';
  }
  const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9ñ]+/g, ' ').trim();
  function resolve(final) {
    const q = norm(input && input.value);
    if (!q) return;
    let hit = items.find((a) => norm(a.name) === q);
    if (!hit) {
      const starts = items.filter((a) => norm(a.name).startsWith(q)), has = items.filter((a) => norm(a.name).includes(q));
      if (starts.length === 1) hit = starts[0]; else if (!starts.length && has.length === 1) hit = has[0];
    }
    if (hit) { select(hit); if (final && input) input.value = hit.name; }
    else if (final) free(input.value.trim());
  }
  if (input) {
    input.addEventListener('input', () => { const q = norm(input.value); const hit = items.find((a) => norm(a.name) === q); if (hit) select(hit); });
    input.addEventListener('change', () => resolve(true));
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); resolve(true); } });
  }
  if (go) go.addEventListener('click', () => resolve(true));
  pins.forEach((p) => p.addEventListener('click', () => { const a = items.find((b) => b.i === +p.dataset.i); if (a) { select(a); if (input) input.value = a.name; } }));
  items.forEach((a) => {
    if (!a.pin) return;
    a.li.addEventListener('mouseenter', () => a.pin.classList.add('is-hover'));
    a.li.addEventListener('mouseleave', () => a.pin.classList.remove('is-hover'));
    a.li.addEventListener('focusin', () => a.pin.classList.add('is-hover'));
    a.li.addEventListener('focusout', () => a.pin.classList.remove('is-hover'));
  });
  /* sort the crawlable list: nearest first (default) or A–Z */
  const sortBtns = $$('[data-sort]', root);
  function sort(by) {
    const order = items.slice().sort(by === 'az' ? (a, b) => a.name.localeCompare(b.name) : (a, b) => a.mi - b.mi);
    order.forEach((a) => list.appendChild(a.li));
    sortBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.sort === by)));
  }
  sortBtns.forEach((b) => b.addEventListener('click', () => sort(b.dataset.sort)));
  if (sortBtns.length) sort('near');
}

/* =====================================================================
   FIND US — open-now badge and the arrival checklist
   ===================================================================== */
function initFindUs(root) {
  openNow(root);
  const bs = $$('.yhp-chk__b', root), done = $('[data-done]', root);
  const upd = () => { if (done) done.textContent = String(bs.filter((b) => b.getAttribute('aria-pressed') === 'true').length); };
  bs.forEach((b) => b.addEventListener('click', () => {
    const on = b.getAttribute('aria-pressed') !== 'true';
    b.setAttribute('aria-pressed', String(on));
    const li = b.closest('.yhp-chk'); if (li) li.classList.toggle('is-done', on);
    upd();
  }));
  upd();
}

/* =====================================================================
   FILTER — chips over a list (Services cards, Related Links)
   ===================================================================== */
function initFilter(root) {
  const chips = $$('.yhp-chips [data-f]', root);
  if (!chips.length) return;
  const items = $$('[data-list] > [data-f]', root), empty = $('.yhp-empty', root);
  const set = (k) => {
    chips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.f === k)));
    let n = 0;
    items.forEach((it) => { const on = k === '*' || it.dataset.f === k; it.hidden = !on; if (on) n += 1; });
    if (empty) empty.hidden = n > 0;
  };
  chips.forEach((c) => c.addEventListener('click', () => set(c.dataset.f)));
}

/* =====================================================================
   TABS — Packages: one tab per program (arrow keys / Home / End move between tabs)
   ===================================================================== */
function initTabs(root) {
  const tabs = $$('[role="tab"]', root), panels = $$('.yhp-panel', root);
  if (!tabs.length) return;
  const set = (i, focus) => {
    tabs.forEach((t, k) => { t.setAttribute('aria-selected', String(k === i)); t.tabIndex = k === i ? 0 : -1; });
    panels.forEach((p, k) => p.classList.toggle('is-on', k === i));
    if (focus) tabs[i].focus();
  };
  tabs.forEach((t, k) => {
    t.addEventListener('click', () => set(k));
    t.addEventListener('keydown', (e) => {
      const n = tabs.length;
      let j = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (k + 1) % n;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (k - 1 + n) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j !== null) { e.preventDefault(); set(j, true); }
    });
  });
}

/* =====================================================================
   STEPS — the homepage stepper: scrubber, prev/next, swipe, arrow keys
   ===================================================================== */
function initSteps(root) {
  const steps = $$('.yhp-step', root), n = steps.length;
  if (n < 2) return;
  const btns = $$('.yh-scrub__steps button', root), prog = $('.yh-scrub__prog', root);
  let i = 0;
  const set = (k, focus) => {
    i = (k + n) % n;
    steps.forEach((s, j) => s.classList.toggle('is-on', j === i));
    btns.forEach((b, j) => { b.setAttribute('aria-pressed', String(j === i)); b.classList.toggle('is-done', j <= i); });
    if (prog) prog.style.width = ((i / (n - 1)) * (100 - 100 / n)).toFixed(3) + '%';
    if (focus && btns[i]) btns[i].focus();
  };
  btns.forEach((b, j) => {
    b.addEventListener('click', () => set(j));
    b.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); set(i + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); set(i - 1, true); }
    });
  });
  $$('[data-go]', root).forEach((b) => b.addEventListener('click', () => set(i + +b.dataset.go)));
  const lst = $('.yhp-steps__list', root);
  if (lst) onSwipe(lst, (d) => set(i + d));
  set(0);
}

/* =====================================================================
   COMPARE — option picker + only-differences toggle
   ===================================================================== */
function initCompare(root) {
  const seg = $$('.yhp-seg [data-c]', root), diff = $('.yhp-cmp__diff', root);
  seg.forEach((b) => b.addEventListener('click', () => {
    root.dataset.show = b.dataset.c;
    seg.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
  }));
  if (diff) diff.addEventListener('click', () => {
    const on = diff.getAttribute('aria-pressed') !== 'true';
    diff.setAttribute('aria-pressed', String(on));
    root.classList.toggle('is-diff', on);
  });
}

/* =====================================================================
   FAQ — accordion (several may be open), Open All / Close All, search
   ===================================================================== */
function initFaq(root) {
  const qas = $$('.yhp-qa', root), all = $('.yhp-faq__all', root), q = $('.yhp-faq__search input', root), empty = $('.yhp-empty', root);
  if (!qas.length) return;
  const btn = (qa) => $('.yhp-qa__b', qa);
  const setOpen = (qa, on) => {
    btn(qa).setAttribute('aria-expanded', String(on));
    $('.yhp-qa__a', qa).hidden = !on;
    qa.classList.toggle('is-open', on);
  };
  const shown = () => qas.filter((qa) => !qa.hidden);
  const syncAll = () => {
    if (!all) return;
    const every = shown().length > 0 && shown().every((qa) => btn(qa).getAttribute('aria-expanded') === 'true');
    all.setAttribute('aria-pressed', String(every));
    all.textContent = every ? all.dataset.close : all.dataset.open;
  };
  qas.forEach((qa, i) => {
    setOpen(qa, i === 0);
    btn(qa).addEventListener('click', () => { setOpen(qa, btn(qa).getAttribute('aria-expanded') !== 'true'); syncAll(); });
  });
  if (all) all.addEventListener('click', () => { const open = all.getAttribute('aria-pressed') !== 'true'; shown().forEach((qa) => setOpen(qa, open)); syncAll(); });
  if (q) q.addEventListener('input', () => {
    const t = q.value.trim().toLowerCase();
    let n = 0;
    qas.forEach((qa, i) => {
      const hit = !t || qa.textContent.toLowerCase().includes(t);
      qa.hidden = !hit;
      if (hit) n += 1;
      setOpen(qa, t ? hit : i === 0);
    });
    if (empty) empty.hidden = n > 0;
    syncAll();
  });
  syncAll();
}

/* =====================================================================
   GALLERY — the homepage stage: thumbnails (links to the large photo), prev/next, swipe, keys, full-screen viewer
   ===================================================================== */
function initGallery(root) {
  const stage = $('[data-stage]', root);
  if (!stage) return;
  const main = $('[data-main-img]', stage), bg = $('[data-bg-img]', stage), cap = $('[data-cap]', stage);
  const thumbs = $$('.yhp-th', root);
  const list = thumbs.length ? thumbs.map((t) => ({ src: t.dataset.src, srcset: t.dataset.srcset, w: t.dataset.w, h: t.dataset.h, alt: t.dataset.alt, cap: t.dataset.cap }))
    : [{ src: main ? main.getAttribute('src') : '', srcset: main ? main.getAttribute('srcset') : '', alt: main ? main.alt : '', cap: cap ? cap.textContent.split(' · ').slice(0, -1).join(' · ') : '' }];
  const n = list.length;
  let i = 0;
  const show = (k) => {
    i = (k + n) % n;
    const g = list[i];
    if (main) {
      if (g.srcset) main.setAttribute('srcset', g.srcset); else main.removeAttribute('srcset');
      main.setAttribute('src', g.src); main.alt = g.alt || '';
      if (g.w && g.h) { main.setAttribute('width', g.w); main.setAttribute('height', g.h); }
    }
    if (bg) { bg.removeAttribute('srcset'); bg.setAttribute('src', g.src); }
    if (cap) cap.textContent = (g.cap || 'You Fly LA · Van Nuys Airport') + ' · ' + (i + 1) + ' / ' + n;
    thumbs.forEach((t, j) => { if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
  };
  thumbs.forEach((t, j) => t.addEventListener('click', (e) => { e.preventDefault(); show(j); }));
  $$('[data-go]', stage).forEach((b) => b.addEventListener('click', () => show(i + +b.dataset.go)));
  const full = () => Viewer.open(list, i, (k) => show(k));
  const fb = $('[data-full]', stage);
  if (fb) fb.addEventListener('click', full);
  if (main) main.addEventListener('click', () => { if (!stage.dataset.swiped) full(); });
  onSwipe(stage, (d) => show(i + d));
  root.addEventListener('keydown', (e) => {
    if (!stage.contains(e.target) && !e.target.closest('.yhp-gal__thumbs')) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); }
  });
}

/* =====================================================================
   TABLE OF CONTENTS — groups a run of consecutive Prose sections with "Include in the table of contents" under a
   sticky rail (desktop) / chip bar (phone), with scrollspy. Skipped in the theme editor (it would move sections).
   ===================================================================== */
function initToc() {
  if (window.Shopify && window.Shopify.designMode) return;
  const secs = $$('.yhp-split[data-toc]');
  if (secs.length < 2) return;
  const wrapOf = (s) => s.closest('.shopify-section') || s;
  const runs = [];
  let cur = null;
  secs.forEach((s) => {
    const w = wrapOf(s);
    if (cur && cur.last.nextElementSibling === w) { cur.items.push(s); cur.last = w; }
    else { cur = { items: [s], last: w }; runs.push(cur); }
  });
  runs.filter((r) => r.items.length > 1).forEach((r, rn) => {
    const first = r.items[0];
    const run = document.createElement('div');
    const scheme = (first.className.match(/yhp-s-(\w+)/) || [])[1] || 'light';
    run.className = 'yh yhp yhp-run yhp-s-' + scheme;
    const title = first.dataset.tocTitle || 'On This Page';
    const aside = document.createElement('nav');
    aside.className = 'yhp-toc';
    aside.setAttribute('aria-label', title);
    aside.innerHTML = `<p class="yh-cap yhp-toc__t">${title.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))}</p><ol></ol>`;
    const ol = $('ol', aside);
    r.items.forEach((s) => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + s.id;
      a.textContent = s.dataset.toc;
      li.appendChild(a); ol.appendChild(li);
    });
    const body = document.createElement('div');
    body.className = 'yhp-run__body';
    const w0 = wrapOf(first);
    w0.parentNode.insertBefore(run, w0);
    run.appendChild(aside); run.appendChild(body);
    r.items.forEach((s) => body.appendChild(wrapOf(s)));
    const links = $$('a', ol);
    const mark = (id) => links.forEach((a) => {
      const on = a.getAttribute('href') === '#' + id;
      if (on) {
        a.setAttribute('aria-current', 'true');
        if (!MQ.desk.matches && ol.scrollWidth > ol.clientWidth) ol.scrollLeft = Math.max(0, a.offsetLeft - 16);
      } else a.removeAttribute('aria-current');
    });
    /* scrollspy: the last section whose top has passed 35% of the viewport (the first one above the run) */
    let last = '', raf = 0;
    const spy = () => {
      raf = 0;
      const line = window.innerHeight * 0.35;
      let id = r.items[0].id;
      r.items.forEach((s) => { if (s.getBoundingClientRect().top <= line) id = s.id; });
      if (id !== last) { last = id; mark(id); }
    };
    /* capture: Horizon scrolls .page-wrapper (not the window) at >= 990px */
    document.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(spy); }, { capture: true, passive: true });
    window.addEventListener('resize', spy);
    spy();
    run.dataset.run = String(rn);
  });
}

/* =====================================================================
   PAGE — in-page links of the reused homepage sections (quiz results "#courses" etc.) when that section is not on
   this page: go to the homepage section instead of nowhere. #discovery and #enroll are left to assets/yfla-book.js.
   ===================================================================== */
const HOME_ANCHORS = ['courses', 'quiz', 'fleet', 'route', 'flight-time', 'simulator', 'why', 'first-flight'];
function initAnchors() {
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || e.defaultPrevented) return;
    const id = a.getAttribute('href').slice(1);
    if (HOME_ANCHORS.indexOf(id) === -1 || document.getElementById(id)) return;
    e.preventDefault();
    window.location.href = '/#' + id;
  });
}

/* =====================================================================
   INIT
   ===================================================================== */
const INIT = {
  hero: initHero, facts: initFacts, nearme: initNearMe, findus: initFindUs, filter: initFilter, tabs: initTabs,
  steps: initSteps, compare: initCompare, faq: initFaq, gallery: initGallery, cta: openNow, split: null
};
function initIn(scope) {
  $$('[data-yhp]', scope || document).forEach((el) => {
    if (el.dataset.yhpInit) return;
    el.dataset.yhpInit = '1';
    const fn = INIT[el.dataset.yhp];
    if (fn) { try { fn(el); } catch (e) { warn(el.dataset.yhp, e); } }
    el.classList.add('is-ready');
  });
}
initIn(document);
try { initToc(); } catch (e) { warn('toc', e); }
try { initAnchors(); } catch (e) { warn('anchors', e); }
document.addEventListener('shopify:section:load', (e) => initIn(e.target));
window.YHP = { version: 'r8', init: initIn, viewer: Viewer };
})();
